import Rest from '@svs/ui/react/icons/Rest';
import type { ReactNode } from 'react';

/**
 * ErrorFallback component to display a user-friendly message when information cannot be displayed.
 *
 * @param props0 props
 * @param props0.text Optional text to display instead of the default message.
 * @returns A ReactNode containing an icon and a message indicating that information cannot be displayed.
 */
export function ErrorFallback({ text }: { text?: string }): ReactNode {
  return (
    <div className="mt-4 mb-4 flex h-full flex-col items-center gap-4 text-lg">
      <span className="text-8xl">
        <Rest />
      </span>
      {text ?? 'För tillfället går det inte att visa någon information.'}
    </div>
  );
}
